/* eslint-disable */
import React, { useState } from "react";
import NavBar from "../../components/shared/NavBar/NavBar";
import styles from "../TermsAndConditions/TermsAndConditions.module.css";
import PrivacyContent from "../../components/privacy/PrivacyContent";
import QuestionIcon from "../../assets/common/question.svg";
import ContactUsCard from "../../components/privacy/ContactUsCard";
import BottomNav from "../../components/shared/BottomNav/BottomNav";

export default function PrivacyPolicy() {
  // State to manage the visibility of the ContactUsCard
  const [isContactCardVisible, setContactCardVisible] = useState(false);

  return (
    <div className={styles.container}>
      <NavBar />
      <BreadcrumbNav />
      <PrivacyContent />
      {isContactCardVisible && (
        <div className={styles["contactus-card"]}>
          <ContactUsCard />
        </div>
      )}
      <FloatingIcon
        onClick={() => {
          setContactCardVisible((prev) => !prev); // Toggle visibility
        }}
      />
    </div>
  );
}

const BreadcrumbNav = () => {
  const date = `Last updated: August 8, 2024`;
  return (
    <div className={styles["breadcrumb"]}>
      <div className={styles["breadcrumb-content"]}>
        <div className={styles["breadcrumb-left"]}>
          <span>Home</span>
          {"  |   "}
          <span className={styles["active-link"]}>Our privacy policy</span>
        </div>
        <div className={styles["breadcrumb-right"]}>{date}</div>
      </div>
      <hr className={styles["breadcrumb-line"]} />
    </div>
  );
};

const FloatingIcon = ({ onClick }) => {
  return (
    <div className={styles["floating-icon"]} onClick={onClick}>
      <img src={QuestionIcon} alt="Question Icon" />
    </div>
  );
};
